const passkey_sign_in = {
    setup_page: {
        title: '簡化你的登入',
        subtitle: '建立通行密鑰',
        description: '使用裝置生物辨識、YubiKey等安全金鑰或其他可用方式註冊你的通行密鑰。',
    },
    trigger_conditional_ui_failed: '無法觸發通行金鑰自動填充。',
};
export default Object.freeze(passkey_sign_in);
